export default __webpack_public_path__ + "static/media/search_banner_2.0dc56034.svg";